import { FC } from 'react';
import { Creators } from '@components/creators';
import { Box, Text } from '@components/design-system';
import { IAccessibility, ICreator } from '@interface/token';
import * as Styles from './styles';

interface ITitles {
  inView: boolean;
  title?: string;
  creators: ICreator[];
  accessibility: IAccessibility;
}

export const Titles: FC<ITitles> = ({ inView, title, creators, accessibility }) => {
  const flashing = accessibility?.hazards ? accessibility?.hazards.indexOf('flashing') !== -1 : false;

  return (
    <Styles.SmallTitle faded={inView}>
      <Box vertical>
        <Text unset ellipsis css={{ fontWeight: 700, overflow: 'hidden', marginRight: '$space$4' }}>
          {title}
        </Text>
        <Creators creators={creators} />
      </Box>

      {flashing && (
        <Box css={{ color: '$secondaryFill', i: { fontSize: 16 } }} vertical>
          <i>bolt</i>
          <Text unset css={{ fontSize: 14, color: 'inherit' }}>
            Photosensitive seizure warning
          </Text>
        </Box>
      )}
    </Styles.SmallTitle>
  );
};
